jQuery(document).ready(function () {
    /**
     *
     */
    $('#addDocLanguage').on('change',function () {
        $(this).closest('form').trigger('submit');
    });

    /**
     *
     */
    $('#addDocSelector').on('submit',function (e) {
        e.preventDefault();
        jQuery.ajax({
            data: $('#addDocSelector').serialize(),
            url: $('#addDocSelector').attr('action')
        }).done(function (html) {
            $("#ScrollProductDoc").html(html);
        });
    });

    /**
     * Remove mini banner slider if it's empty
     */
    if ($("#product-slider .container .item").length <= 0) {
        $(".wrap-product-slider .container").html("");
    }

    /**
     * Remove product push if it's empty
     */
    if ($("#push-product .list-product .list-content .item").length <= 0) {
        $("#push-product .container").html("");
    }
    displyClaimDisclaimer();
});

jQuery(document).ready(function () {
    $('#addDocLanguage').closest('form').trigger('submit');
});

/**
 *
 */
function displyClaimDisclaimer() {
    $(function () {
        $(function () {
            $(".claim").tooltip({
                track: true,
                items: "p",
                content: function () {
                    var claimDisclaimer = $(this).closest(".main-claim").find("div.claim-disclaimer").text();
                    return claimDisclaimer;
                },
                show: {
                    effect: "slideDown",
                    delay: 250
                }
            });
        });
    });
}

function isValidEmailAddress() {
    /**
     *
     * @type {*|jQuery}
     */
    var emailAddress = $("#email").val();

    /**
     *
     * @type {RegExp}
     */
    var pattern = new RegExp('[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}');
    if (pattern.test(emailAddress)) {
        $("#companionEmailError").hide();
        $("#companionClubForm").trigger('submit');
    }
    else {
        $("#companionEmailError").show();
    }
}

/**
 *
 */
jQuery("#companionClubForm").on('submit', function (event) {
    /**
     *
     */
    var baseURL = jQuery("#companionClubForm").attr('action');
    jQuery("#messageErrors").html('');
    jQuery("#messageSuccess").html('');
    event.preventDefault();
    jQuery.ajax({
        type: "POST",
        data: jQuery("#companionClubForm").serialize(),
        url: baseURL
    }).done(function (data) {
        if (data.success == true) {
            $('#newLetterSubsModal').modal('show');
            $(".modal-body").html(data.message);
            $('.modal').on('hidden.bs.modal', function () {
                $.clearFormFields($("#companionClubForm"));
            });
        } else {
            $('#newLetterSubsModal').modal('show');
            jQuery("#messageErrors").text(data.message);
            $(".modal-body").html(data.message);
            $('.modal').on('hidden.bs.modal', function () {
                $.clearFormFields($("#companionClubForm"));
            });
        }
    }).fail( function () {
        jQuery("#messageErrors").text(data.message);
        $('#newLetterSubsModal').modal('show');
        $('.modal').on('hidden.bs.modal', function () {
            $.clearFormFields($("#companionClubForm"));
        });
    });
});

/**
 *
 * @param area
 */
$.clearFormFields = function (area) {
    $(area).find('input[type="text"]').val('');
};


///BRA-6165: Griser le bouton submit du formulaire de création de compte après validation
$("#FormCreateProfile").on("submit",function(e){$(this).find("button.btn-action").attr("disabled","disabled");});

/* Start BRA-5278 */
$(document).ready(function () {
	 // autocomplete detached Pieces
	 var productCode = $("#detachedPieceForm #productCode").val();
	 $(function () {
	     $("#detachedPieceForm #accessoryCode").autocomplete({
	         source: function (request, response) {
	             $.ajax({
	                 url: ACC.config.contextPath + "/exploded-view/" + productCode + "/detail-exp-view/auto-compelte",
	                 type: "GET",
	                 dataType: "json",
	                 data: {term: request.term}
	             }).done( function (data) {
                     console.log(data);
                     response(data);
                 });
	         }
	     });
	 });
	});
/* End BRA-5278 */

/* BRA-5659 : Start*/
function checkRightToDeletAccount(element,event,checkCart) {
	var urlValidation = $($(element)).attr('data');
	var params = {"checkCart": checkCart};
	$.ajax({
        url: urlValidation, async: false, data:params
    }).done(function (data) {
        if(data == "CART_IN"){
            $("#ModalRemoveCart").show();
            $("#ModalRemoveCart").modal();
        }else if (data == 'NOK') {
        	event.preventDefault();
            $("#ModalBlockDeleteAccount").show();
            $("#ModalBlockDeleteAccount").modal();
        }else if(data == 'OK'){
        	event.preventDefault();
            $("#ModalDeleteAccount").show();
            $("#ModalDeleteAccount").modal();
        }

    }).fail(function (data) {
    	event.preventDefault();
    	console.log("Error in validing account deletion !");
    });
}
/* BRA-5659 : END*/


jQuery(document).ready(function() {
	if($(".our-applications-carousel a").length<4)
	{
		$(".our-applications-carousel").hide();
	}
});

jQuery(document).ready(function() {

    //Display offers popin
    var displayTimeout=$(".offer-popin").data("timeout")*1000;
    setTimeout(function(){
    	if($(".offer-popin").length){
	    	$(".offer-popin").modal();
    	}
    }, displayTimeout);
    //Display offers popin
});

$(function () {
    if ($('.page-MobileApplicationListPage')) {
        $('.our-applications .our-applications-listing-item .our-applications-listing-download-infos-wrapper span').on('click',function (e) {
            e.preventDefault();
            var index = $(this).data('our-app-index');
            console.log(index);
            $('#mobileapp-compatibility-popin-' + index).modal();
            Modal.show();
        });
    }
});

$(document).ready(function () {
	if($(window).width() > 720){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});

$(window).resize(function () {
	if($(window).width() > 720){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});
